import { Template } from 'api/techexpress/schema';
import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';

export const DeleteTemplateConfirmationDialog = ({
  isOpen,
  close,
  onConfirmation,
  dynamicProps,
}: {
  isOpen: boolean;
  close: () => void;
  onConfirmation: (template?: Template) => void;
  dynamicProps?: Template;
}) => (
  <Modal isVisible={isOpen} close={close} className="max-w-[624px]">
    <div className="space-y-12 rounded-t-lg bg-background-base-surface-2 p-8">
      <div className="space-y-2">
        <h1 className="text-content-base-default">
          Are you sure you want to delete this template?
        </h1>
        <p className="font-bold text-content-base-subdued">
          This action cannot be undone. Once deleted, all template data will be
          removed forever.
        </p>
      </div>
      <div className="flex gap-5">
        <GraniteButton size="large" variant="secondary" onClick={close}>
          Cancel
        </GraniteButton>
        <GraniteButton
          size="large"
          variant="destructive"
          onClick={() => {
            onConfirmation(dynamicProps);
          }}
        >
          Yes, delete template
        </GraniteButton>
      </div>
    </div>
  </Modal>
);
